export enum UITheme {
  DarkAccent = 'simx-theme--dark-accent',
  DarkNeutral = 'simx-theme--dark-neutral',
  LightNeutral = 'simx-theme--light-neutral',
  White = 'simx-theme--white',
}
